import { Component, OnInit, Input } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {MatSnackBar} from '@angular/material/snack-bar';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from 'app/auth/auth.service';
import { PerfilUsuarioService } from "../perfil-usuario.service";
import Swal from 'sweetalert2';

@Component({
  selector: 'configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.scss']
})
export class ConfiguracionComponent implements OnInit {

  @Input() datosUsuario: Observable<any>;

  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';
  charIdiomas = this.charChinos + this.charTurcos;
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

  datosUsu: any;

  cambioCorreo: any = {
    correo: '',
    codigo: '',
    contrasenia: '',
    confirmarPass: ''
  };
  aptoCambio = false;
  tokenTemporal: number;
  statusCodigo = false;
  cambioPass: any = {
    contrasenia: '',
    confirmarPass: ''
  };
  status2FA: boolean;

  constructor(
    private translateSrv: TranslateService,
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    private perfilUsuarioService: PerfilUsuarioService
  ) { }

  ngOnInit() {
    this.datosUsuario.subscribe((datos:any) => {
      if (datos != null) {
        console.log("datosUsuario:",datos);
        this.datosUsu = datos;
        this.get2FAStatus();
      }
    });
  }

  get2FAStatus(){
    this.perfilUsuarioService.get2FAStatus(this.datosUsu.user).subscribe((respuesta:any) => {
      console.log("get2FAStatus:",respuesta);
      if(respuesta.success){
        this.status2FA = respuesta.userData.twoFactorAuthentication;
      }
    });
  }

  set2FAStatus(){
    let datos = {
      flagAuthentication: this.status2FA
    };
    this.perfilUsuarioService.set2FAStatus(datos, localStorage.getItem('idUsuario')).subscribe((respuesta:any) => {
      console.log("set2FAStatus:",respuesta);
      if(respuesta.success){
        this._snackBar.open(this.translateSrv.instant('PERFIL_USUARIO.MODALES.AUTHOK'), "OK", {
          duration: 2000,
          horizontalPosition: "center",
          verticalPosition: "bottom",
          panelClass: ['background-red']
        });
      }
    });
  }

  cambiarEmail_paso1(){
    if(this.datosUsu.user != this.cambioCorreo.correo){
      let idiomaNavegador = navigator.language.split("-");
      let idiomaCGO: string;
      let datos = {
        user: this.cambioCorreo.correo,
        language: idiomaNavegador[0],
        brokerId: localStorage.getItem('instituto_id')
      };
      this.perfilUsuarioService.enviarCodigo(datos, localStorage.getItem('idUsuario')).subscribe((respuesta:any) => {
        console.log("enviarCodigo:",respuesta);
        if(respuesta.success){
          this.tokenTemporal = respuesta.keyVerify;
          this.aptoCambio = true;
          this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIARMAIL_PASO1_OK"),3);
        } else{
          if(respuesta.message == "User already exist"){
            this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIARMAIL_PASO1_NOTOK"),2);
          }
        }
      }, error => {
        console.log(error);
      });
    } else{
      this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIARMAIL_PASO1_SAME"),4);
    }
  }
  cambiarEmail_paso2(){
    if(this.cambioCorreo.codigo == this.tokenTemporal){
      this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIARMAIL_PASO2_OK"),1);
      this.statusCodigo = true;
    } else{
      this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIARMAIL_PASO2_NOTOK"),4);
    }
  }
  cambiarEmail_paso3(){
    if(this.cambioCorreo.contrasenia == this.cambioCorreo.confirmarPass){
      this.cambiarPass(true);
    } else{
      this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIARMAIL_PASO3_NOTOK"),4);
    }
  }
  cambiarPass(cambioUsuario?:boolean){
    if(this.cambioPass.contrasenia == this.cambioPass.confirmarPass || cambioUsuario){
      if(this.validaPassSegura(cambioUsuario)){
        let datos={
          level: this.datosUsu.level,
          institutoId: this.datosUsu.institutoId,
          user: cambioUsuario != null ? this.cambioCorreo.correo : this.datosUsu.user,
          password: cambioUsuario != null ? this.cambioCorreo.confirmarPass : this.cambioPass.confirmarPass,
          empresaId: this.datosUsu.empresaId,
        };
        this.perfilUsuarioService.actualizaUsuariosEmpresas(datos, localStorage.getItem('idUsuario')).subscribe((respuesta:any) => {
          console.log("actualizaUsuario:",respuesta);
          if(respuesta.success){
            this.reiniciaFormularios();
            if(cambioUsuario){
              this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIARMAIL_PASO3_OK"),1,true);
            } else{
              this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIAPASS_OK"),1);
            }
          }
        }, error => {
          console.log(error);
        });
      }
    } else{
      this.mensajeSwal(this.translateSrv.instant("PERFIL_USUARIO.MODALES.CAMBIAPASS_NOTOK"),4);
    }
  }

  reiniciaFormularios(){
    this.cambioCorreo = {
      correo: '',
      codigo: '',
      contrasenia: '',
      confirmarPass: ''
    };
    this.cambioPass = {
      contrasenia: '',
      confirmarPass: ''
    };
  }

  validaPassSegura(cambioUsuario?:boolean){
    let status = false;
    let passActual = cambioUsuario != null ? this.cambioCorreo.confirmarPass : this.cambioPass.confirmarPass;
    let regexPass = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*([_]|[ -\/]|[:-\@]|[[-\`]|[{-\■])).{8,64}$");
    let regexMin = new RegExp("^(?=.*[a-z]).{1,64}$");
    let regexMay = new RegExp("^(?=.*[A-Z]).{1,64}$");
    let regexNum = new RegExp("^(?=.*[0-9]).{1,64}$");
    let regexCharEsp = new RegExp("[_]|[ -\/]|[:-\@]|[[-\`]|[{-\■]");
    console.log("passActual:",passActual);
    if(passActual.length > 7){
      if(regexMin.test(passActual)){
        if(regexMay.test(passActual)){
          if(regexNum.test(passActual)){
            if(regexCharEsp.test(passActual)){
              if(regexPass.test(passActual)){
                status = true;
              } else{
                //no pasó la validacion completa
                console.log("no pasó la validacion completa");
                this.mensajeSwal(this.translateSrv.instant('ALERTS.PASSWORD.VALIDACION'),2);
              }
            } else{
              //sin caracteres especiales
              console.log("sin caracteres especiales");
              this.mensajeSwal(this.translateSrv.instant('ALERTS.PASSWORD.ESPCHARS'),2);
            }
          } else{
            //sin numeros
            console.log("sin numeros");
            this.mensajeSwal(this.translateSrv.instant('ALERTS.PASSWORD.NUMEROS'),2);
          }
        } else{
          //sin mayusculas
          console.log("sin mayusculas");
          this.mensajeSwal(this.translateSrv.instant('ALERTS.PASSWORD.MAYUSCULAS'),2);
        }
      } else{
        //modal sin minusculas
        console.log("modal sin minusculas");
        this.mensajeSwal(this.translateSrv.instant('ALERTS.PASSWORD.MINUSCULAS'),2);
      }
    } else{
      console.log("longitud minima");
      this.mensajeSwal(this.translateSrv.instant('ALERTS.PASSWORD.LONGITUD'),2);
    }
    return status;
  }

  mensajeSwal(mensaje:string, tipo:number, logout?:boolean){
    let tipoMensaje:any;
    switch (tipo) {
      case 1: //success
        tipoMensaje = 'success';
      break;
      case 2: //warning
        tipoMensaje = 'warning';
      break;
      case 3: //info
        tipoMensaje = 'info';
      break;
      case 4: //error
        tipoMensaje = 'error';
      break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipoMensaje,
      
      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar')
    }).then((result) => {
      if (result.value) {
        if(logout){
          console.log("se va a cerrar sesion");
          this.authService.logout();
        }
      }
    });
  }

}
